export default "__VITE_ASSET__DmJVCBqZ__"